import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    background: #14111e url(/assets/layout-own-ai-man/pride/background.png)
      no-repeat center center;
    background-size: 100% 100%;

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 16px;
    }

    .app-logo {
      margin: 20px 0 20px;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    font-weight: 600;
  }
`;

export const PageSubtitleStyles = styled(UiTypography)`
  .ion-page & {
    color: transparent;
  }
`;

export const BackgroundImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
`;

export const MainImage = styled.img`
  position: absolute;
  z-index: 2;
  bottom: 0;
  object-fit: contain;
`;
